import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpErrorHandlerService } from "../helpers/http-error-handler.service";
import { catchError, firstValueFrom } from "rxjs";
import {
	IAstimaxContactManualContacts,
	ICreateAstimaxContactManualContacts,
	IUpdateAstimaxContactManualContacts
} from "./plugin-user-data.interface";
import { API_ENDPOINT_PATH, API_HTTP_HEADERS } from "../helpers/api-constant";

@Injectable({
  providedIn: 'root'
})
export class PluginUserDataService {
	readonly #headers: HttpHeaders
	readonly #urlEndpoint: string

	constructor(
		private readonly http: HttpClient,
		private readonly errorHandlerService: HttpErrorHandlerService
	) {
		this.#urlEndpoint = `${API_ENDPOINT_PATH}/pluginUserData`;
		this.#headers = new HttpHeaders(API_HTTP_HEADERS);
	}

	private getUrl(): string {
		return `${this.#urlEndpoint}`
	}

	private getHeader(): HttpHeaders {
		return this.#headers
	}

	// Manual contact always adjusts to the user
	async upsertManualContact(user_id: string, payload: ICreateAstimaxContactManualContacts | IUpdateAstimaxContactManualContacts, contact_id?: string): Promise<IAstimaxContactManualContacts|{}> {
		let queryUrl = `${this.getUrl()}/${user_id}`;

		if (contact_id) {
			queryUrl = `${this.getUrl()}/${user_id}/${contact_id}`;
		}

		const result = this.http.post<IAstimaxContactManualContacts>(`${queryUrl}`, payload,
			{ headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
		return await firstValueFrom(result)
	}

	async getManualContactById(user_id: string, contact_id: string): Promise<IAstimaxContactManualContacts|{}> {
		let queryUrl = `${this.getUrl()}/${user_id}/${contact_id}`

		const result = this.http.get<IAstimaxContactManualContacts>(`${queryUrl}`,
			{ headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForSingleRecord))
		return await firstValueFrom(result)
	}

	async getAllManualContacts(user_id: string): Promise<IAstimaxContactManualContacts[]> {
		let queryUrl = `${this.getUrl()}/${user_id}`

		const result = this.http.get<IAstimaxContactManualContacts[]>(`${queryUrl}`,
			{ headers: this.getHeader() }).pipe(catchError(this.errorHandlerService.handleErrorForRecords))
		return await firstValueFrom(result)
	}

	async deleteManualContactById(user_id: string, contact_id: string): Promise<any> {
		const headers = this.getHeader().delete('Content-Type').delete('content-type');

		let queryUrl = `${this.getUrl()}/${user_id}/${contact_id}`;
		const result = this.http.delete(`${queryUrl}`,
			{ headers: headers }).pipe(catchError(this.errorHandlerService.handleError))
		return await firstValueFrom(result)
	}
}
